// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from './application';

import QrAssociationSelect from './admin/qr_association_select_controller';

import QrImage from './admin/qr_image_controller';

application.register('qr-association-select', QrAssociationSelect);
application.register('qr-image', QrImage);
